import { currencyToSymbol } from 'utils/currencies';

import useCurrency from './useCurrency';

const useCurrencySymbol = (): string => currencyToSymbol(useCurrency());

export default useCurrencySymbol;
